import { waitForElem } from '../../utils/wait_for_elem';

const clear_form_selector = '#countdown';

function countdown(matchedElems: HTMLElement[], counterRef: { value: number }) {
  if (counterRef.value > 0) {
    counterRef.value = counterRef.value - 1;
    matchedElems[0].textContent = `${counterRef.value}`;
    const url = window.location.href;
    if (counterRef.value === 1) {
      if (url.indexOf('/library/') > 0) {
        window.location.href = "/library/"
      } else
      if (url.indexOf('/blog/') > 0) {
        window.location.href = "/blog/"
      } else
      if (url.indexOf('/news/') > 0) {
        window.location.href = "/news/"
      } else {
        /* If a referer exists, redirect there. */
        window.location.href = "/";
      }
    }
  }
}

waitForElem(clear_form_selector).then((matchedElems: HTMLElement[]) => {
  if (matchedElems) {
    const counterRef = { value: 10 };
    setInterval(function() {
      countdown(matchedElems, counterRef);
    }, 1000);
  }
});
